/* Avra Medical - funnel de lead-gen (cotizacion + WhatsApp)
 * - window.avraQuote(title,url): abre el modal global con contexto de producto
 * - dispara evento LEAD (Meta fbq / Google gtag / dataLayer) al enviar cotizacion
 * - POST opcional del lead a un webhook de GHL (window.AVRA.ghl)
 * - barra CTA sticky en movil en paginas de producto
 * No depende de nada: si el pixel/gtag/GHL no existen, degrada en silencio. */
(function () {
  var A = window.AVRA || {};
  var GHL = (A.ghl || '').trim();
  var ctx = { product: '', url: '' };

  // Estilos de la barra sticky (inyectados; no toca theme.css)
  var css =
    '#avraStickyCta{position:fixed;left:0;right:0;bottom:0;z-index:95;display:none;gap:10px;padding:10px 14px;background:rgba(255,255,255,.97);border-top:1px solid #e2e8f0;box-shadow:0 -4px 16px rgba(0,0,0,.08);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}' +
    '#avraStickyCta .avra-sticky-quote{flex:1;border:none;border-radius:8px;background:#1e293b;color:#fff;font-weight:700;font-size:16px;padding:14px;font-family:inherit;cursor:pointer;line-height:1.2}' +
    '#avraStickyCta .avra-sticky-quote:active{background:#0f172a}' +
    '#avraStickyCta .avra-sticky-wa{display:flex;align-items:center;justify-content:center;width:52px;border-radius:8px;background:#25D366;text-decoration:none;flex-shrink:0}' +
    '@media(max-width:768px){#avraStickyCta{display:flex}body.template-product{padding-bottom:78px}}';
  try { var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st); } catch (e) {}

  // Abrir modal global de cotizacion con contexto del producto (collection/featured cards)
  window.avraQuote = function (title, url) {
    ctx.product = title || '';
    ctx.url = url || (window.location ? window.location.href : '');
    var msg = document.getElementById('gqMessage');
    if (msg && ctx.product) { msg.value = 'Me interesa cotizar: ' + ctx.product + (ctx.url ? ' (' + ctx.url + ')' : ''); }
    var modal = document.getElementById('globalQuoteModal');
    if (modal) { modal.style.display = 'flex'; }
    else { window.location.href = '/pages/contacto'; }
  };

  function val(id) { var el = document.getElementById(id); return el ? (el.value || '') : ''; }

  function currentProductName() {
    var el = document.querySelector('.product-title');
    return el ? el.textContent.trim() : ctx.product;
  }

  // Evento LEAD + webhook GHL
  function fireLead(data) {
    try { if (typeof fbq === 'function') fbq('track', 'Lead', { content_name: data.product || 'Cotizacion', currency: 'MXN', value: 0 }); } catch (e) {}
    try { if (typeof gtag === 'function') gtag('event', 'generate_lead', { currency: 'MXN', value: 0, item_name: data.product || 'Cotizacion' }); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'lead_submit', lead_source: data.source, product: data.product || '', page: data.page || '' }); } catch (e) {}
    if (GHL) {
      try { fetch(GHL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data), keepalive: true }); } catch (e) {}
    }
  }

  function collectProduct() {
    return {
      source: 'cotizacion_producto',
      name: val('quoteName'), company: val('quoteCompany'), email: val('quoteEmail'),
      phone: val('quotePhone'), profile: val('quoteProfile'), notes: val('quoteNotes'), qty: val('quoteQty'),
      product: currentProductName(), page: (window.location ? window.location.href : '')
    };
  }

  function collectGlobal() {
    return {
      source: 'cotizacion_global',
      name: val('gqName'), company: val('gqCompany'), email: val('gqEmail'),
      phone: val('gqPhone'), notes: val('gqMessage'),
      product: ctx.product, page: (window.location ? window.location.href : '')
    };
  }

  function wire() {
    var pf = document.getElementById('quoteForm');
    if (pf && !pf.__avra) { pf.__avra = 1; pf.addEventListener('submit', function () { fireLead(collectProduct()); }); }
    var gf = document.querySelector('#globalQuoteModal form');
    if (gf && !gf.__avra) { gf.__avra = 1; gf.addEventListener('submit', function () { fireLead(collectGlobal()); }); }
  }

  // Barra CTA sticky en movil (solo paginas de producto)
  function stickyBar() {
    if (!document.body || document.body.className.indexOf('template-product') === -1) return;
    if (document.getElementById('avraStickyCta')) return;
    var wa = (A.wa || '').replace(/\D/g, '');
    var waBtn = '';
    if (wa && wa.length >= 10) {
      waBtn = '<a href="https://wa.me/' + wa + '?text=' + encodeURIComponent('Hola, quiero cotizar un equipo oftalmologico') + '" target="_blank" rel="noopener" class="avra-sticky-wa" aria-label="WhatsApp">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="#fff"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/></svg></a>';
    }
    var bar = document.createElement('div');
    bar.id = 'avraStickyCta';
    bar.innerHTML =
      '<button type="button" class="avra-sticky-quote">Solicitar Cotizaci&oacute;n</button>' + waBtn;
    document.body.appendChild(bar);
    bar.querySelector('.avra-sticky-quote').addEventListener('click', function () {
      var m = document.getElementById('quoteModal');
      if (m) { m.style.display = 'flex'; } else { window.avraQuote('', ''); }
    });
  }

  function init() { wire(); stickyBar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
